import { TableString } from './../../../../models/table-string.model';

export class User {
	public userID: number;
	public userName: string;
	public firstName: string;
	public lastName: string;
	public emailId: string;
	
	public roleId: number;
	public roleData: TableString;

	public isActive: boolean;
	public isDelete: boolean;
	public createdOn: Date | number | string;
	public createdBy: number;
	public modifyOn: Date | number | string;
	public modiyBy: number;


	public initialize(rolesSelectionData: TableString[]) {
		if (rolesSelectionData) {
			this.roleData = rolesSelectionData.find((tableString) => tableString.id === this.roleId);
		}
	}

	public prepareForSave() {
		this.roleId = this.roleData.id;
	}
}

export class UserPassword {
	public Action: string;
	public OldPassword: string;
	public NewPassword: string;
	public UserId: number;
	public Param1: string; 
	public Param2: string;
} 
